import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { OpenCreateRecordDialogService } from '../../core/services/open-create-record-dialog.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateHubRecordDialogComponent } from '../create-hub-record-dialog/create-hub-record-dialog.component';
import { LogoutNotificationComponent } from '../logout-notification/logout-notification.component';
import { environment } from 'src/environments/environment';
import { HeaderComponent } from './layout/header/header.component';
import { AppStateService } from '../../core/services/app-state.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {
    public gaTrackingId: string;
    public title: string = 'Hub - Home';
    public isSidebarOpened: boolean = true;
    public toggleQuickLinksSidebar: boolean = false;
    private createHubRecordRequestedSubscription: Subscription;
    private autoLogoutDialogReference: MatDialogRef<LogoutNotificationComponent, any>;
    public showBanner: boolean = false;

    @ViewChild("header")
    public header: HeaderComponent;

    public get isSidebarExpanded(): boolean {
        return this.appStateService.isSidebarExpanded;
    }

    constructor(
        private authService: AuthService,
        private openCreateRecordDialogService: OpenCreateRecordDialogService,
        private dialogService: MatDialog,
        private appStateService: AppStateService
    ) {
        this.authService.showAutoLogoutNotification.subscribe(() => {
            this.autoLogoutDialogReference = this.dialogService.open(LogoutNotificationComponent, {
                width: '640px',
                maxWidth: 'none',
                disableClose: true
            });
        });
        this.authService.closeAutoLogoutNotification.subscribe(() => {
            if (this.autoLogoutDialogReference) {
                this.dialogService.closeAll();
            }
        });
    }

    ngOnInit() {
        this.authService.setupAuthorizationCallback();
        this.showBanner = environment.showNonProdNotification;

        this.createHubRecordRequestedSubscription = this.openCreateRecordDialogService.createHubRecordRequested.subscribe(() => {
            this.dialogService.open(CreateHubRecordDialogComponent, {
                width: '800px',
                maxWidth: 'none'
            });
        });
    }

    public ngOnDestroy() {
        if (this.createHubRecordRequestedSubscription) {
            this.createHubRecordRequestedSubscription.unsubscribe();
        }
        if (this.authService.showAutoLogoutNotification) {
            this.authService.showAutoLogoutNotification.unsubscribe();
        }
        if (this.authService.closeAutoLogoutNotification) {
            this.authService.closeAutoLogoutNotification.unsubscribe();
        }
    }

    public isLoggedIn(): boolean {
        return this.authService.isLoggedIn();
    }

}
